<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <div class="selectBox">
          <span class="selectText">对账时间</span>
          <el-date-picker
            size="mini"
            v-model="createTime"
            @change="createTimeChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <!-- <template #chae="slotData">
        <div v-if="slotData.data.row.type == 1">
          {{ parseFloat(((slotData.data.row.signTotalEpg * 1000 + slotData.data.row.mallRefoundAmount * 1000 - slotData.data.row.userTotalAmount * 1000 - slotData.data.row.busiCurrentAmount * 1000 - slotData.data.row.busiFrozenAmount * 1000 - slotData.data.row.busiWithdrawTotalAmount * 1000 - slotData.data.row.mallConsumeEpg * 1000) / 1000).toPrecision(12)) }}
        </div>
        <div v-if="slotData.data.row.type == 2">
          {{parseFloat(((slotData.data.row.signTotalEpg * 1000 - slotData.data.row.userTotalAmount * 1000 - slotData.data.row.busiTotalAmount * 1000 - slotData.data.row.bulkyConsumeEpg * 1000 - slotData.data.row.busiWithdrawTotalAmount * 1000 - slotData.data.row.mallConsumeEpg * 1000) / 1000).toPrecision(12)) }}
        </div>
      </template> -->
      <!-- <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleEdit(slotData.data.row)">修改</el-button>
        <el-button type="danger" size="mini" @click="handleDelete(slotData.data.row.id)">删除</el-button>
      </template> -->
    </e-table>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";

import { postAction } from '@/api/manage';

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable },
  mixins: [listMixin],
  props: {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  data() {
    return {
      createTime: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      url: {
        list: "/wlFinancialStatement/queryPage",
      },
      // loadWithGet: true,
      //字段权限
      columns: [
        {
          field: "createTime",
          label: "对账时间",
          width: "200px",
        },
        {
          field: "recyclableSignTotalEpg",
          label: "可回收物签收总环保金",
        },
        {
          field: "recyclableRetracementTotalEpg",
          label: "可回收物撤回总环保金",
        },
        {
          field: "hpSignTotalEpg",
          label: "家电签收总环保金",
        },
        {
          field: "hpRetracementTotalEpg",
          label: "家电撤回总环保金",
        },
        {
          field: "retracementTotalEpg",
          label: "撤回总环保金",
        },
        {
          field: "signTotalEpg",
          label: "签收总环保金",
        },
        {
          field: "userCurrentAmount",
          label: "用户当前余额",
        },
        {
          field: "userFrozenAmount",
          label: "用户冻结金额",
        },
        {
          field: "userRefoundAmount",
          label: "用户退款金额",
        },
        {
          field: "userTotalAmount",
          label: "用户总余额",
        },
        {
          field: "busiCurrentAmount",
          label: "商家当前余额",
        },
        {
          field: "busiFrozenAmount",
          label: "商家冻结金额",
        },
        {
          field: "busiTotalAmount",
          label: "商家总余额",
        },
        {
          field: "busiWithdrawTotalAmount",
          label: "商家已完成提现总金额",
        },
        {
          field: "bulkyConsumeEpg",
          label: "大件清运消费环保金",
        },
        {
          field: "bulkyRefoundEpg",
          label: "大件清运退款环保金",
        },
        {
          field: "mallConsumeEpg",
          label: "商城消费环保金",
        },
        {
          field: "mallRefoundAmount",
          label: "商城退款环保金",
        },
        {
          field: "mallCompensateAmount",
          label: "商城补偿环保金",
        },
        {
          field: "totalPrice",
          label: "差额",
        },
        // {
        //   width: 260,
        //   label: '操作',
        //   slotName: 'handlerSlot',
        //   columnType: 'slot',
        // },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    searchReset() {
      this.queryParam = {};
      this.createTime = "";
      this.loadData(1);
    },
    createTimeChange(date) {
      if (date) {
        this.queryParam.createTimeStart = date[0] + " 00:00:00";
        this.queryParam.createTimeEnd = date[1] + " 23:59:59";
      } else {
        this.queryParam.createTimeStart = "";
        this.queryParam.createTimeEnd = "";
      }
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error("请设置url.list属性!");
        return;
      }
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();
      this.loading = true;

      if (this.loadOtherData) {
        this.loadOtherData(params);
      }
      postAction(this.url.list, params).then((res) => {
        if (res.msg) {
          this.$message.warning(res.msg);
          return;
        }
        res.data.records.forEach((item) => {
          let signTotalEpg = new BigNumber(item.signTotalEpg);
          let userTotalAmount = new BigNumber(item.userTotalAmount);
          let busiCurrentAmount = new BigNumber(item.busiCurrentAmount);
          let busiFrozenAmount = new BigNumber(item.busiFrozenAmount);
          let busiWithdrawTotalAmount = new BigNumber(
            item.busiWithdrawTotalAmount
          );
          let mallConsumeEpg = new BigNumber(item.mallConsumeEpg);
          let bulkyConsumeEpg = new BigNumber(item.bulkyConsumeEpg);
          if (item.type == 1) {
            let mallRefoundAmount = new BigNumber(item.mallRefoundAmount);
            item.totalPrice = signTotalEpg
              .plus(mallRefoundAmount)
              .minus(userTotalAmount)
              .minus(bulkyConsumeEpg)
              .minus(busiCurrentAmount)
              .minus(busiFrozenAmount)
              .minus(busiWithdrawTotalAmount)
              .minus(mallConsumeEpg)
              .toNumber();
          }
          if (item.type == 2) {
            // let bulkyConsumeEpg = new BigNumber(item.bulkyConsumeEpg);
            let busiTotalAmount = new BigNumber(item.busiTotalAmount);
            item.totalPrice = signTotalEpg
              .minus(userTotalAmount)
              .minus(busiTotalAmount)
              .minus(bulkyConsumeEpg)
              .minus(busiWithdrawTotalAmount)
              .minus(mallConsumeEpg)
              .toNumber();
          }
        });
        this.dataSource = res.data.records;
        if (res.data.total) {
          this.ipagination.total = res.data.total;
        } else {
          this.ipagination.total = 0;
        }

        this.loading = false;
      });
    },
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  // width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
